/* eslint-disable @typescript-eslint/no-explicit-any */
// components/Analytics.tsx
'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';

declare global {
  interface Window {
    gtag: (...args: any[]) => void;
  }
}

const Analytics = () => {
  const pathname = usePathname();

  useEffect(() => {
    if (typeof window.gtag === 'function') {
      window.gtag('config', 'G-N6BQ62SB20', {
        page_path: pathname,
      });
    }
  }, [pathname]);

  return null;
};

export default Analytics;
